export default __webpack_public_path__ + "static/media/ProximamenteES.05f6a1a9.png";